import { render, staticRenderFns } from "./create_student_modal.vue?vue&type=template&id=7ac866c8&scoped=true&"
import script from "./create_student_modal.vue?vue&type=script&lang=js&"
export * from "./create_student_modal.vue?vue&type=script&lang=js&"
import style0 from "./create_student_modal.vue?vue&type=style&index=0&id=7ac866c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac866c8",
  null
  
)

export default component.exports